import { render } from "./NotFoundView.vue?vue&type=template&id=1fff985f"
const script = {}

import "./NotFoundView.vue?vue&type=style&index=0&id=1fff985f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__